<template>
<v-list dense two-line subheader>
    <v-subheader v-if='title' ><strong>{{title}}</strong></v-subheader>
    <v-divider></v-divider>
    <v-list-tile
      v-for="key in displayFields" :key="key" >
      <v-list-tile-content>
          <v-list-tile-title>{{ value[key] }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ key.replace(/_/g, ' ') }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
</v-list>
</template>

<script>
export default {
  name: 'ObjectListView',
  props: {
    title: { type: String },
    value: { type: Object, default: () => { return {} } },
    fields: { type: Array },
    ignoredFields: { type: Array }
  },
  computed: {
    displayFields () {
      let all = []
      if (this.value) {
        all = Object.keys(this.value)
        if (this.fields) {
          all = all.filter((field) => {
            return this.fields.indexOf(field) !== -1
          })
        }
        if (this.ignoredFields) {
          all = all.filter((field) => {
            return this.ignoredFields.indexOf(field) === -1
          })
        }
      }
      return all
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ObjectListView.vue?45424fea